module.exports = __webpack_public_path__ + "static/media/rocket.1decd111.svg";